import { createGlobalState } from '@vueuse/core';
import { computed, ref } from 'vue';
import { useDisposes } from '@telecom/shared/composables/use-disposes';
import { EmbodimentRulesService } from '../service/embodiment-rules-service';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import type { EmbodimentRule, SelectedClaimFeature, SelectedKeyword } from '../types';

export const useEmbodimentRules = createGlobalState(() => {
    const embodimentRuleService = injectService<EmbodimentRulesService>(EmbodimentRulesService);

    const { disposes } = useDisposes();

    const modelData = ref<EmbodimentRule[]>(embodimentRuleService.getModelData());
    disposes.push(embodimentRuleService.onStateChange(state => modelData.value = state));

    const embodimentRules = computed(() => modelData.value);

    const disabledSubmitRule = computed(() => {
        return embodimentRules.value.every(rule => !rule.keyword.value);
    });

    function createNewRule() {
        embodimentRuleService.createRule();
    }

    function deleteRule(id: string) {
        embodimentRuleService.deleteRule(id);
    }

    function updateRules(rules: EmbodimentRule[]) {
        embodimentRuleService.updateRules(rules);
    }

    function submitRule() {
        embodimentRuleService.submitRules();
    }

    function updateFeature(id: string, feature: SelectedClaimFeature) {
        embodimentRuleService.updateFeature(id, feature);
    }

    function updateKeyword(id: string, keyword: SelectedKeyword) {
        embodimentRuleService.updateKeyword(id, keyword);
    }

    return {
        embodimentRules,
        disabledSubmitRule,
        createNewRule,
        deleteRule,
        updateRules,
        submitRule,
        updateFeature,
        updateKeyword,
    };
});
